import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import React from 'react';

import Button from 'components/basic/Button';
import Icon, { IconTypes } from 'components/basic/Icon';
import { Caption } from 'components/basic/Typography';

import s from './AcceptCookie.module.scss';

interface Props {
  showSettings: () => void;
  onClose: () => void;
}

export default function AcceptCookie({
  showSettings,
  onClose,
}: Props): JSX.Element {
  const t = useTranslationAndTypograph();

  return (
    <div className={s.textWrapper}>
      <Caption className={s.text}>
        {t(`Is it ok if we use cookies to make this site easy and safe for you?
We respect your privacy,`)}{' '}
        <a
          href="https://welltory.com/cookie/"
          className={s.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('here is how.')}
        </a>
      </Caption>
      <div className={s.buttonsWrapper}>
        <Icon
          onClick={showSettings}
          className={s.settingsIcon}
          icon={IconTypes.settings}
          size={24}
        />
        <Button size="small" look="secondary" onClick={onClose}>
          sure
        </Button>
      </div>
    </div>
  );
}
